import React, { useEffect, useState } from 'react';

const ManageDashboard = ({ backendUrl, resetKey }) => {
  const [settings, setSettings] = useState({
    mainMedia: [],
    title: '',
    subtitle: '',
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${backendUrl}/dashboard-settings`);
        const data = await res.json();
        if (data.success && data.settings) {
          setSettings(data.settings);
        }
      } catch (err) {
        console.error('Error loading dashboard settings', err);
      }
    };
    fetchSettings();
  }, [resetKey]);

  const handleMediaChange = (index, field, value) => {
    const updated = [...settings.mainMedia];
    updated[index][field] = value;
    setSettings({ ...settings, mainMedia: updated });
  };

  const addMedia = () => {
    setSettings({ ...settings, mainMedia: [...settings.mainMedia, { type: 'image', url: '' }] });
  };

  const removeMedia = (index) => {
    const updated = settings.mainMedia.filter((_, i) => i !== index);
    setSettings({ ...settings, mainMedia: updated });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings({ ...settings, [name]: value });
  };

  const saveSettings = async () => {
    try {
      const token = localStorage.getItem('auth-token');
      const res = await fetch(`${backendUrl}/dashboard-settings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': token,
        },
        body: JSON.stringify(settings),
      });
      const result = await res.json();
      if (result.success) alert('Dashboard settings updated!');
      else alert('Error saving settings');
    } catch (err) {
      console.error(err);
      alert('Error saving settings');
    }
  };

  return (
    <div className="form-group">
      <h2>Manage Homepage Media</h2>
      {settings.mainMedia.map((media, i) => (
        <div key={i}>
          <label>Type</label>
          <select
            value={media.type}
            onChange={(e) => handleMediaChange(i, 'type', e.target.value)}
          >
            <option value="image">Image</option>
            <option value="video">Video</option>
          </select>
          <label>URL</label>
          <input
            type="text"
            value={media.url}
            onChange={(e) => handleMediaChange(i, 'url', e.target.value)}
          />
          <button onClick={() => removeMedia(i)}>Remove</button>
        </div>
      ))}
      <button onClick={addMedia}>Add Media</button>
      <label>Title</label>
      <input name="title" value={settings.title} onChange={handleChange} />
      <label>Subtitle</label>
      <input name="subtitle" value={settings.subtitle} onChange={handleChange} />
      <button onClick={saveSettings}>Save Settings</button>
    </div>
  );
};

export default ManageDashboard;